import { sortByTimeOldestFirst } from './SortUtils';
import { isEmpty } from 'lodash';
import { formatDate, getTime } from './TimeUtils';
import AppointmentTime from '../dto/AppointmentTime';
import { getInsideParentheses } from './Functions';

const mapToReschedule = (appointment) => {
  return {
    dateStart: getTime(appointment.dateStart),
    dateEnd: getTime(appointment.dateEnd),
    appointmentId: appointment.appointmentId,
    slotId: appointment.slotId,
    visitType: appointment.visitType,
    location: appointment.location,
  };
};

const mapToReservation = (appointment) => {
  return {
    ...appointment,
    dateStart: getTime(appointment.dateStart),
    dateEnd: getTime(appointment.dateEnd),
  };
};

const mapForCalendar = (data, mappingFunction) => {
  return data.reduce((acc, appointment) => {
    let day = formatDate(appointment.dateStart);
    let appointmentData = mappingFunction(appointment);
    if (isEmpty(acc[day])) {
      acc[day] = {
        day: getTime(appointment.dateStart).startOf('day'),
        times: [appointmentData],
      };
    } else {
      acc[day].times.push(appointmentData);
    }
    return acc;
  }, {});
};

export const mapRescheduleTimesForCalendar = (data) =>
  mapForCalendar(
    data.filter((a) => !a.original),
    mapToReschedule
  );

export const mapReservationTimesForCalendar = (data) =>
  mapForCalendar(data, mapToReservation);

export const mapSelectedAppointmentForCalendar = (appointment) => {
  return {
    dateStart: getTime(appointment.dateStart),
    dateEnd: getTime(appointment.dateEnd),
    appointmentId: appointment.appointmentId,
    slotId: appointment.slotId,
    visitType: appointment.visitType,
    location: appointment.location,
  };
};

export const mapRescheduleAppointmentsForList = (data) => {
  return data
    .sort(sortByTimeOldestFirst('dateStart'))
    .filter((appointment) => !appointment.original)
    .map(AppointmentTime.of);
};

export const mapReservationAppointmentsForList = (data) => {
  return data.sort(sortByTimeOldestFirst('dateStart')).map((appointment) => {
    return {
      dateStart: getTime(appointment.dateStart),
      dateEnd: getTime(appointment.dateEnd),
      locationId: appointment.locationId,
      scheduleId: appointment.scheduleId,
    };
  });
};

export const resolveComment = (selectedClinicKey, selectedReasonKey) => {
  return selectedClinicKey + '.option.' + selectedReasonKey;
};

export const resolveClinic = (location) => {
  let visitTypeCode = getInsideParentheses(location);
  if (visitTypeCode) {
    return visitTypeCode;
  } else {
    return null;
  }
};
